import { useSelector } from 'react-redux';
import { DROPDOWN_PLACEHOLDER_ID } from '../../../../utils/constants';

const menuNameOf = (row) => {
    const name = Array.isArray(row?.cMenuName) ? row.cMenuName[0] : row?.cMenuName
    return `${name || ''}`.trim().toLowerCase()
}

/*
  Type / vendor / menu item options for a cutoff, with the same rules as the
  cutoff form: the items are those of the vendor's menus set up for the type.
  `values` needs userType, vendorId and menuItemId; `setFieldValue` is formik's.
*/
export default function useCutoffItemOptions(values, setFieldValue) {
    const {
        EmployeeReducers: { vendorName },
        MenuItemMasterReducers: { menuItemMasterList },
        MenuMasterReducers: { menuMasterList, mealDropdownList }
    } = useSelector((state) => state)

    const vendorOptions = vendorName || []
    const typeOptions = ((mealDropdownList.length && mealDropdownList[2]) || []).filter((t) => +t.id !== DROPDOWN_PLACEHOLDER_ID)

    const selectedType = typeOptions.find((t) => +t.id === +values.userType) || null
    const selectedVendor = vendorOptions.find((v) => +v.id === +values.vendorId) || null

    const itemsFor = (vendor, type) => {
        if (!vendor || !type) return []
        const menus = new Set(
            (menuMasterList || [])
                .filter((m) => `${m.cVendorName || ''}`.trim().toLowerCase() === `${vendor?.name || ''}`.trim().toLowerCase())
                .map(menuNameOf)
        )
        return (menuItemMasterList || []).filter((m) => menus.has(menuNameOf(m)) && +m.typeID === +type)
    }

    const menuItemOptions = itemsFor(selectedVendor, values.userType)
    const selectedMenuItem = menuItemOptions.find((m) => +m.nID === +values.menuItemId) || null

    // The picked item may not belong to the new vendor / type any more
    const keepMenuItemIfValid = (vendor, type) => {
        if (itemsFor(vendor, type).some((m) => +m.nID === +values.menuItemId)) return
        setFieldValue('menuItemId', '')
        setFieldValue('menuItemName', '')
        setFieldValue('menuId', '')
    }

    return {
        typeOptions, vendorOptions, menuItemOptions, selectedType, selectedVendor, selectedMenuItem,
        handleTypeChange: (value) => {
            setFieldValue('userType', value ? value.id : '')
            keepMenuItemIfValid(selectedVendor, value?.id)
        },
        handleVendorChange: (value) => {
            setFieldValue('vendorId', value ? value.id : '')
            keepMenuItemIfValid(value, values.userType)
        },
        handleMenuItemChange: (value) => {
            setFieldValue('menuItemId', value ? value.nID : '')
            setFieldValue('menuItemName', value ? value.cItemName : '')
            setFieldValue('menuId', value ? value.nMenuID : '')
        },
    }
}
